import React from "react"
import "@assets/scss/components/app-loader.scss"

const logo = "/img/logo/logo_small.png"
class SpinnerComponent extends React.Component {
  render() {
    return (<></>)
  }
}

export default SpinnerComponent
